/**
 * The footer of a centred dialog (design-language §4): Cancel then the primary action at the
 * bottom right, pinned while the body scrolls, clear of the home indicator on a phone. Dialogs
 * built on `Sheet` render it as the last child of their body, so the header keeps only the title
 * and ×.
 */
import type { ReactNode } from 'react'
import './dialogs.css'

export function DialogFooter({ children, note }: { children: ReactNode; note?: ReactNode }) {
  return (
    <div className="dlg-foot">
      {note ? <span className="dlg-foot__note">{note}</span> : <span className="flex-1" />}
      {children}
    </div>
  )
}
